export const bidangData = {
    sekretariat: {
        nama: "Sekretariat",
        kepala: "Nama Kepala Sekretariat",
        nip: "19650101 199003 1 001",
        tusi: {
            tugas: [
                "Menyusun rencana program dan kegiatan kesekretariatan",
                "Mengelola urusan kepegawaian, keuangan, dan umum",
                "Melaksanakan koordinasi penyusunan peraturan perundang-undangan",
                "Mengelola urusan rumah tangga, perlengkapan, dan aset",
                "Melaksanakan monitoring, evaluasi, dan pelaporan kinerja",
                "Memberikan pelayanan administrasi kepada seluruh bidang"
            ],
            fungsi: [
                "Penyusunan rencana strategis dan program kerja BPKAD",
                "Pengelolaan administrasi kepegawaian dan pengembangan SDM",
                "Pengelolaan keuangan internal BPKAD",
                "Pelaksanaan urusan surat menyurat dan kearsipan",
                "Pengelolaan sarana dan prasarana kantor",
                "Pelaksanaan kehumasan dan protokol",
                "Koordinasi penyusunan laporan kinerja instansi"
            ]
        },
        struktur: [
            { jabatan: "Kepala Sekretariat", nama: "Nama Pejabat" },
            { jabatan: "Kasubbag Umum dan Kepegawaian", nama: "Nama Pejabat" },
            { jabatan: "Kasubbag Keuangan", nama: "Nama Pejabat" },
            { jabatan: "Kasubbag Perencanaan", nama: "Nama Pejabat" }
        ],
        galeri: [
            { id: 1, title: "Rapat Koordinasi Internal", date: "2024-01-20", image: "https://placehold.co/600x400/1E3A8A/FFFFFF?text=Rapat+Koordinasi" },
            { id: 2, title: "Pelatihan SDM BPKAD", date: "2024-01-15", image: "https://placehold.co/600x400/0D9488/FFFFFF?text=Pelatihan+SDM" },
            { id: 3, title: "Penandatanganan Kinerja", date: "2024-01-10", image: "https://placehold.co/600x400/0F172A/FFFFFF?text=Penandatanganan" },
            { id: 4, title: "Apel Pagi Rutin", date: "2024-01-05", image: "https://placehold.co/600x400/1E3A8A/FFFFFF?text=Apel+Pagi" }
        ]
    },

    asset: {
        nama: "Bidang Asset",
        kepala: "Nama Kepala Bidang Asset",
        nip: "19680101 199103 1 002",
        tusi: {
            tugas: [
                "Melaksanakan pengelolaan barang milik daerah",
                "Menyusun kebijakan teknis pengelolaan aset daerah",
                "Melakukan inventarisasi dan penilaian aset daerah",
                "Mengelola pemanfaatan dan pemindahtanganan aset",
                "Melaksanakan pengamanan dan pemeliharaan aset",
                "Menyusun laporan pengelolaan aset daerah"
            ],
            fungsi: [
                "Perumusan kebijakan teknis pengelolaan BMD",
                "Pelaksanaan inventarisasi dan sensus barang daerah",
                "Penatausahaan dan pembukuan barang milik daerah",
                "Pengelolaan pemanfaatan barang milik daerah (sewa, pinjam pakai, KSP)",
                "Pelaksanaan pemindahtanganan dan pemusnahan aset",
                "Pengawasan dan pengendalian pengelolaan aset",
                "Penyusunan laporan barang milik daerah"
            ]
        },
        struktur: [
            { jabatan: "Kepala Bidang Asset", nama: "Nama Pejabat" },
            { jabatan: "Kasi Perencanaan Kebutuhan", nama: "Nama Pejabat" },
            { jabatan: "Kasi Pemanfaatan", nama: "Nama Pejabat" },
            { jabatan: "Kasi Penatausahaan", nama: "Nama Pejabat" }
        ],
        galeri: [
            { id: 1, title: "Inventarisasi Aset Daerah", date: "2024-02-10", image: "https://placehold.co/600x400/0D9488/FFFFFF?text=Inventarisasi+Aset" },
            { id: 2, title: "Penilaian Kendaraan Dinas", date: "2024-02-05", image: "https://placehold.co/600x400/1E3A8A/FFFFFF?text=Penilaian+Kendaraan" },
            { id: 3, title: "Serah Terima Aset", date: "2024-01-28", image: "https://placehold.co/600x400/0F172A/FFFFFF?text=Serah+Terima" },
            { id: 4, title: "Sensus Barang Daerah", date: "2024-01-20", image: "https://placehold.co/600x400/0D9488/FFFFFF?text=Sensus+Barang" }
        ]
    },

    pendapatan: {
        nama: "Bidang Pendapatan",
        kepala: "Nama Kepala Bidang Pendapatan",
        nip: "19700101 199203 1 003",
        tusi: {
            tugas: [
                "Melaksanakan pengelolaan pendapatan daerah",
                "Menyusun kebijakan teknis pemungutan pendapatan",
                "Melakukan intensifikasi dan ekstensifikasi pendapatan",
                "Mengelola sistem informasi pendapatan daerah",
                "Melaksanakan monitoring dan evaluasi pendapatan",
                "Menyusun laporan realisasi pendapatan daerah"
            ],
            fungsi: [
                "Perumusan kebijakan teknis pengelolaan pendapatan",
                "Pelaksanaan pendataan dan pendaftaran wajib pajak/retribusi",
                "Penetapan dan penagihan pajak daerah dan retribusi",
                "Pengelolaan sistem pembayaran online",
                "Intensifikasi dan ekstensifikasi sumber pendapatan",
                "Pembinaan dan pengawasan pemungutan pendapatan",
                "Penyusunan laporan realisasi pendapatan daerah"
            ]
        },
        struktur: [
            { jabatan: "Kepala Bidang Pendapatan", nama: "Nama Pejabat" },
            { jabatan: "Kasi Pendataan dan Pendaftaran", nama: "Nama Pejabat" },
            { jabatan: "Kasi Penetapan dan Penagihan", nama: "Nama Pejabat" },
            { jabatan: "Kasi Pembukuan dan Pelaporan", nama: "Nama Pejabat" }
        ],
        galeri: [
            { id: 1, title: "Sosialisasi Pajak Daerah", date: "2024-02-15", image: "https://placehold.co/600x400/0F172A/FFFFFF?text=Sosialisasi+Pajak" },
            { id: 2, title: "Launching e-Retribusi", date: "2024-02-01", image: "https://placehold.co/600x400/0D9488/FFFFFF?text=e-Retribusi" },
            { id: 3, title: "Pembinaan Wajib Pajak", date: "2024-01-25", image: "https://placehold.co/600x400/1E3A8A/FFFFFF?text=Pembinaan+WP" },
            { id: 4, title: "Monitoring Pendapatan", date: "2024-01-15", image: "https://placehold.co/600x400/0F172A/FFFFFF?text=Monitoring" }
        ]
    },

    perbendaharaan: {
        nama: "Bidang Perbendaharaan",
        kepala: "Nama Kepala Bidang Perbendaharaan",
        nip: "19720101 199303 1 004",
        tusi: {
            tugas: [
                "Melaksanakan pengelolaan perbendaharaan daerah",
                "Menyusun kebijakan teknis penatausahaan keuangan",
                "Melaksanakan penerbitan SP2D",
                "Mengelola kas daerah",
                "Melaksanakan verifikasi dan akuntansi pengeluaran",
                "Menyusun laporan arus kas dan posisi kas"
            ],
            fungsi: [
                "Perumusan kebijakan teknis perbendaharaan",
                "Pelaksanaan penatausahaan pengeluaran daerah",
                "Penerbitan Surat Penyediaan Dana (SPD)",
                "Penerbitan Surat Perintah Membayar (SPM)",
                "Penerbitan Surat Perintah Pencairan Dana (SP2D)",
                "Pengelolaan kas umum daerah",
                "Penyusunan laporan arus kas pemerintah daerah"
            ]
        },
        struktur: [
            { jabatan: "Kepala Bidang Perbendaharaan", nama: "Nama Pejabat" },
            { jabatan: "Kasi Pengeluaran", nama: "Nama Pejabat" },
            { jabatan: "Kasi Verifikasi", nama: "Nama Pejabat" },
            { jabatan: "Kasi Kas Daerah", nama: "Nama Pejabat" }
        ],
        galeri: [
            { id: 1, title: "Verifikasi SPJ", date: "2024-02-12", image: "https://placehold.co/600x400/1E3A8A/FFFFFF?text=Verifikasi+SPJ" },
            { id: 2, title: "Rapat TEPRA", date: "2024-02-08", image: "https://placehold.co/600x400/0D9488/FFFFFF?text=Rapat+TEPRA" },
            { id: 3, title: "Bimtek Pengelolaan Keuangan", date: "2024-01-30", image: "https://placehold.co/600x400/0F172A/FFFFFF?text=Bimtek+Keuangan" },
            { id: 4, title: "Rekonsiliasi Kas", date: "2024-01-22", image: "https://placehold.co/600x400/1E3A8A/FFFFFF?text=Rekonsiliasi" }
        ]
    },

    anggaran: {
        nama: "Bidang Anggaran",
        kepala: "Nama Kepala Bidang Anggaran",
        nip: "19740101 199403 1 005",
        tusi: {
            tugas: [
                "Melaksanakan penyusunan anggaran daerah",
                "Menyusun kebijakan teknis penganggaran",
                "Melaksanakan koordinasi penyusunan APBD",
                "Mengelola dokumen pelaksanaan anggaran (DPA)",
                "Melaksanakan monitoring dan evaluasi pelaksanaan anggaran",
                "Menyusun laporan realisasi anggaran"
            ],
            fungsi: [
                "Perumusan kebijakan teknis penganggaran",
                "Penyusunan KUA-PPAS (Kebijakan Umum Anggaran-Prioritas Plafon Anggaran Sementara)",
                "Penyusunan RKA-SKPD (Rencana Kerja Anggaran)",
                "Penyusunan APBD dan APBD Perubahan",
                "Penerbitan DPA-SKPD",
                "Monitoring dan evaluasi pelaksanaan anggaran",
                "Penyusunan laporan realisasi anggaran"
            ]
        },
        struktur: [
            { jabatan: "Kepala Bidang Anggaran", nama: "Nama Pejabat" },
            { jabatan: "Kasi Penyusunan Anggaran", nama: "Nama Pejabat" },
            { jabatan: "Kasi Pengesahan DPA", nama: "Nama Pejabat" },
            { jabatan: "Kasi Monitoring Anggaran", nama: "Nama Pejabat" }
        ],
        galeri: [
            { id: 1, title: "Musrenbang RKPD", date: "2024-03-05", image: "https://placehold.co/600x400/0D9488/FFFFFF?text=Musrenbang" },
            { id: 2, title: "Pembahasan KUA-PPAS", date: "2024-02-28", image: "https://placehold.co/600x400/1E3A8A/FFFFFF?text=KUA-PPAS" },
            { id: 3, title: "Sinkronisasi Anggaran", date: "2024-02-15", image: "https://placehold.co/600x400/0F172A/FFFFFF?text=Sinkronisasi" },
            { id: 4, title: "Rapat Evaluasi Anggaran", date: "2024-02-01", image: "https://placehold.co/600x400/0D9488/FFFFFF?text=Evaluasi" }
        ]
    },

    akuntansi: {
        nama: "Bidang Akuntansi",
        kepala: "Nama Kepala Bidang Akuntansi",
        nip: "19760101 199503 1 006",
        tusi: {
            tugas: [
                "Melaksanakan akuntansi dan pelaporan keuangan daerah",
                "Menyusun kebijakan teknis akuntansi pemerintah daerah",
                "Melaksanakan rekonsiliasi data keuangan",
                "Menyusun laporan keuangan pemerintah daerah",
                "Mengelola sistem informasi akuntansi",
                "Melaksanakan pembinaan akuntansi SKPD"
            ],
            fungsi: [
                "Perumusan kebijakan teknis akuntansi pemerintah daerah",
                "Pelaksanaan sistem akuntansi pemerintahan daerah",
                "Rekonsiliasi data keuangan dengan SKPD",
                "Penyusunan laporan keuangan semesteran dan tahunan",
                "Penyusunan neraca daerah",
                "Pembinaan dan bimbingan teknis akuntansi SKPD",
                "Pengelolaan sistem informasi akuntansi daerah"
            ]
        },
        struktur: [
            { jabatan: "Kepala Bidang Akuntansi", nama: "Nama Pejabat" },
            { jabatan: "Kasi Akuntansi Penerimaan", nama: "Nama Pejabat" },
            { jabatan: "Kasi Akuntansi Pengeluaran", nama: "Nama Pejabat" },
            { jabatan: "Kasi Pelaporan", nama: "Nama Pejabat" }
        ],
        galeri: [
            { id: 1, title: "Penyusunan LKPD", date: "2024-03-10", image: "https://placehold.co/600x400/1E3A8A/FFFFFF?text=Penyusunan+LKPD" },
            { id: 2, title: "Rekonsiliasi Data", date: "2024-03-05", image: "https://placehold.co/600x400/0D9488/FFFFFF?text=Rekonsiliasi" },
            { id: 3, title: "Bimtek Akuntansi SKPD", date: "2024-02-20", image: "https://placehold.co/600x400/0F172A/FFFFFF?text=Bimtek+Akuntansi" },
            { id: 4, title: "Audit BPK", date: "2024-02-10", image: "https://placehold.co/600x400/1E3A8A/FFFFFF?text=Audit+BPK" }
        ]
    }
};